import React from "react";
import { useSnackbar } from "notistack";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CheckCircleOutlineIcon from "@material-ui/icons/CheckCircleOutline";
import InfoOutlinedIcon from "@material-ui/icons/InfoOutlined";
import useStyles from "./OrderToast.styles";

const ICONS = {
  success: CheckCircleOutlineIcon,
  info: InfoOutlinedIcon,
};

const OrderToast = React.forwardRef(function OrderToast(
  { id, message, variant = "success" },
  ref
) {
  const classes = useStyles();
  const { closeSnackbar } = useSnackbar();
  const Icon = ICONS[variant] || ICONS.success;

  return (
    <div ref={ref} className={`${classes.toast} ${classes[variant]}`}>
      <Icon className={classes.icon} />
      <span className={classes.message}>{message}</span>
      <IconButton
        size="small"
        className={classes.close}
        onClick={() => closeSnackbar(id)}
      >
        <CloseIcon fontSize="small" />
      </IconButton>
    </div>
  );
});

export default OrderToast;
